import type { Wealthlane_CapTable_Dtos_CharterFiling_UpdateStockClassDetailsDto } from '@wealthlane/api-services/wealthlane-captable-service';

export function mapEditedRowsToDetailsPayload(
  charterFilingId: string,
  editedRows: Record<string, unknown>[],
): Wealthlane_CapTable_Dtos_CharterFiling_UpdateStockClassDetailsDto {
  return {
    charterFilingId,
    details: editedRows.map((row) => ({
      detailId: row.id as string,
      className: row.name as string,
      defaultIdPrefix: (row.preFix as string | null | undefined) ?? null,
      classType: row.classType as number,
      totalAuthorized:
        row.authorizedShares != null ? Number(row.authorizedShares) : null,
      votesPerShare: row.votesPerShare != null ? Number(row.votesPerShare) : null,
      seniority: row.seniority != null ? Number(row.seniority) : null,
      conversionRatio:
        row.conversionRatio != null ? Number(row.conversionRatio) : null,
      splitMultiplier:
        row.splitMultiplier != null ? Number(row.splitMultiplier) : null,
      parValue: row.parValue != null ? Number(row.parValue) : null,
      originalIssuePrice:
        row.originalIssuePrice != null && row.originalIssuePrice !== ''
          ? Number(row.originalIssuePrice)
          : null,
      dividendRate:
        row.dividendRate != null && row.dividendRate !== ''
          ? Number(row.dividendRate)
          : null,
      dividendType:
        row.dividendType != null && row.dividendType !== ''
          ? Number(row.dividendType)
          : undefined,
      clearDividendType: row.dividendType === '' ? true : undefined,
    })),
  };
}
